import alertIcon from '@iconify/icons-ant-design/exclamation-circle-filled'
import warningIcon from '@iconify/icons-ant-design/warning-filled'
import { ContactStatus } from 'shared/types'
import { Wrapper, Text, Icon } from './ContactStatusErrorMessage.style'

interface ContactStatusErrorMessageProps {
  title: string
  icon?: boolean
  status?: ContactStatus
}

const ContactStatusErrorMessage = ({
  title,
  status,
  icon,
  ...props
}: ContactStatusErrorMessageProps) => (
  <Wrapper {...props}>
    {icon && (
      <Icon
        contactStatus={status}
        icon={status === ContactStatus.ERROR ? alertIcon : warningIcon}
      />
    )}
    <Text contactStatus={status}>{title}</Text>
  </Wrapper>
)

export default ContactStatusErrorMessage
